'use strict';

var React = require('react');

const LazyContext = React.createContext({ strict: false });

exports.LazyContext = LazyContext;
//# sourceMappingURL=LazyContext.cjs.map
